"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.period.lastWeek': '上周',
    'reports.period.lastMonth': '上月',
    'reports.period.last3Months': '过去3个月',
    'reports.period.lastYear': '去年',
    'reports.period.allTime': '所有时间',
    'reports.period.custom': '自定义范围',
};
